import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String };

  refresh(event) {
    const periodEnd = event.target.value;
    if (!periodEnd) return;

    get(this.urlValue, {
      query: { period_end: periodEnd },
      responseKind: "turbo-stream",
    });
  }
}
